import React, { useState } from 'react'
import { useLocale } from '../localization/LocaleProvider'

function LanguageSelect() {
  const [displayLanguageSelect, setDisplayLanguageSelect] = useState(false);
  const locale = useLocale();


  if(displayLanguageSelect)
  return (
    <div className="flex flexCenter" style={{gap: 4}}>
      <select
        value={locale.locale} 
        onChange={(e) => {
        locale.setLocale(e.target.value);
        setDisplayLanguageSelect(false);
      }}>
        <option value="en">English</option>
        <option value="sv">Svenska</option>
      </select>
      <i className="fa fa-times-circle-o" aria-hidden="true" style={{fontSize: 18, cursor: "pointer"}} onClick={() => setDisplayLanguageSelect(false)}></i>
    </div>
  )

  return (
    <span className='flex flexCenter' onClick={() => setDisplayLanguageSelect(!displayLanguageSelect)} style={{gap: 4, cursor: "pointer"}}>
    <i className="fa fa-globe" aria-hidden="true" style={{fontSize: 24}}></i>
    {locale.locale == 'en' ? 'English' : 'Svenska'}
    </span> 
  )
}

export default LanguageSelect